import { createResource } from "~/lib/resourceFactory";
import { getBankingConnections } from "./banking.api";

type BankingConnectionsPage = Awaited<ReturnType<typeof getBankingConnections>>;

export type StagedTransactionsParams = {
  businessId: string;
  status?: "pending" | "approved" | "skipped";
  offset?: number;
  limit: number;
  dateFrom?: string;
  dateTo?: string;
};

export const bankingQueryKeys = {
  overview: (businessId: string) =>
    ["banking", "overview", businessId] as const,
  connections: (businessId: string) =>
    ["banking", "connections", businessId] as const,
  bankAccounts: (businessId: string) =>
    ["banking", "bank-accounts", businessId] as const,
  staged: (p: StagedTransactionsParams) =>
    [
      "banking",
      "staged",
      p.businessId,
      p.status ?? "pending",
      p.offset ?? 0,
      p.limit,
      p.dateFrom ?? "",
      p.dateTo ?? "",
    ] as const,
  rules: (businessId: string) => ["banking", "rules", businessId] as const,
};

export const BankingConnectionsResource = createResource<
  BankingConnectionsPage,
  { businessId: string }
>({
  key: (p) => bankingQueryKeys.connections(p.businessId),
  fetcher: (p) => getBankingConnections({ data: p }),
  staleTime: 30_000,
});
